import React, {useEffect, useState} from "react";
import Container from "react-bootstrap/Container";
import {Alert, Breadcrumb, Col, Row, Table} from "react-bootstrap";
import {Link} from "react-router-dom";
import ScheduleItem from "./schedule.item.component";
import ScheduleService from "../../services/schedule.service";
import PFDateAndDesc from "../../common/pfDateAndDesc";

const AllSchedule = () => {

    const [allScheduleVenues, setAllScheduleVenues] = useState([])

    const fetchSchedule = () => {
        ScheduleService.getAllSchedule().then(
            response => {
                setAllScheduleVenues(response.data.data);
                console.log("allScheduleVenues:" + JSON.stringify(response.data.data));
            },
            error => {
                console.log(error);
            });
    }

    // load once on mount
    useEffect(() => {
        fetchSchedule();
    }, []);  // eslint-disable-line react-hooks/exhaustive-deps

    const today = new Date();
    const month = today.toLocaleString('default', {month: 'long'});
    const day = today.getDate();
    const year = today.getFullYear();

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <h3>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Schedule</Breadcrumb.Item>
                            </Breadcrumb>
                        </h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <PFDateAndDesc/>
                        <Alert variant="info">
                            <p className="fs-6">
                                <strong>
                                    Please note: This is the schedule as of {month} {day}, {year}. The final
                                    schedule will be released at the end of May.
                                </strong>
                            </p>
                            <p className="fs-6">
                                If you have registered as a performer and don't see your name in the schedule below,
                                then you are not currently scheduled to be part of Porchfest 🙁.
                            </p>
                            <p className="fs-6">
                                We encourage you to reach out to venue owners that have available slots and see if they
                                are willing to host you. <strong>You can find these slots in green below</strong>.
                            </p>
                            <p className="fs-6">
                                If you find the venue and slot you like, click on the "Contact" button and
                                fill out the form to let the owner know you are interested in a match. Once you agree
                                to a match, the venue owner will schedule you in one of their available slots and you
                                will be all set for Porchfest!
                            </p>
                        </Alert>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <Table bordered hover size="lg" responsive className="schedule-table">
                            <thead>
                            <tr>
                                <th>Location</th>
                                <th width="21%">12pm - 1:00pm</th>
                                <th width="21%">1:30pm - 2:30pm</th>
                                <th width="21%">3:00pm - 4:00pm</th>
                                <th width="21%">4:30pm - 5:30pm</th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td colSpan={5} style={{textAlign: "center", height: "75px", background: "#ffffea"}}
                                    className="align-middle">
                                    Porchfest Finale: Diver9 at The Griffin Museum Terrace (67 Shore Rd) from 6:00p to
                                    7:30p
                                </td>
                            </tr>
                            {allScheduleVenues.length > 0 &&
                                allScheduleVenues.map((si) => (
                                        <tr key={si.id}>
                                            <td>
                                                <Link to={si.address_url} target="_blank"
                                                      reloadDocument="true"><span
                                                    style={{textTransform: 'capitalize'}}>{si.address}</span></Link>
                                            </td>
                                            {si.slot_1 !== null && si.slot_1.type === "scheduled" &&
                                                <td className="schedule-td-scheduled">
                                                    <ScheduleItem siSlot={si.slot_1} venueId={si.id}/>
                                                </td>
                                            }
                                            {si.slot_1 !== null && si.slot_1.type === "available" &&
                                                <td className="schedule-td-available">
                                                    <ScheduleItem siSlot={si.slot_1} venueId={si.id}/>
                                                </td>
                                            }
                                            {si.slot_1 == null &&
                                                <td className="schedule-td-unavailable">
                                                    <span className="schedule-act-desc">Slot not available</span>
                                                </td>
                                            }

                                            {si.slot_2 !== null && si.slot_2.type === "scheduled" &&
                                                <td className="schedule-td-scheduled">
                                                    <ScheduleItem siSlot={si.slot_2} venueId={si.id}/>
                                                </td>
                                            }
                                            {si.slot_2 !== null && si.slot_2.type === "available" &&
                                                <td className="schedule-td-available">
                                                    <ScheduleItem siSlot={si.slot_2} venueId={si.id}/>
                                                </td>
                                            }
                                            {si.slot_2 == null &&
                                                <td className="schedule-td-unavailable">
                                                    <span className="schedule-act-desc">Slot not available</span>
                                                </td>
                                            }

                                            {si.slot_3 !== null && si.slot_3.type === "scheduled" &&
                                                <td className="schedule-td-scheduled">
                                                    <ScheduleItem siSlot={si.slot_3} venueId={si.id}/>
                                                </td>
                                            }
                                            {si.slot_3 !== null && si.slot_3.type === "available" &&
                                                <td className="schedule-td-available">
                                                    <ScheduleItem siSlot={si.slot_3} venueId={si.id}/>
                                                </td>
                                            }
                                            {si.slot_3 == null &&
                                                <td className="schedule-td-unavailable">
                                                    <span className="schedule-act-desc">Slot not available</span>
                                                </td>
                                            }

                                            {si.slot_4 !== null && si.slot_4.type === "scheduled" &&
                                                <td className="schedule-td-scheduled">
                                                    <ScheduleItem siSlot={si.slot_4} venueId={si.id}/>
                                                </td>
                                            }
                                            {si.slot_4 !== null && si.slot_4.type === "available" &&
                                                <td className="schedule-td-available">
                                                    <ScheduleItem siSlot={si.slot_4} venueId={si.id}/>
                                                </td>
                                            }
                                            {si.slot_4 == null &&
                                                <td className="schedule-td-unavailable">
                                                    <span className="schedule-act-desc">Slot not available</span>
                                                </td>
                                            }
                                        </tr>
                                    )
                                )
                            }
                            <tr>
                                <td colSpan={5} style={{textAlign: "center", height: "75px", background: "#ffffea"}}
                                    className="align-middle">
                                    Porchfest Finale: Diver9 at The Griffin Museum Terrace (67 Shore Rd) from 6:00p to
                                    7:30p
                                </td>
                            </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default AllSchedule;
